<template>
    <div>
        <table class="table table-borderless">
            <thead>
                <tr>
                    <th colspan="2">{{ $t('Kokkuvõte') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in invoice.items">
                    <td class="text-left py-0 pt-3">{{ item.name }} ({{ item.qty }} {{ $t('tk') }})</td>
                    <td class="text-right py-0 pt-3" style="width: 25%">
                        <strong>{{ Filters.formatFloat(item.price) }} €</strong>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="table table-borderless">
            <tbody>
                <tr>
                    <td class="text-left py-0">
                        <strong>{{ $t('Käibemaks') }}</strong>
                    </td>
                    <td class="text-right py-0" style="width: 25%">
                        <strong>{{ Filters.formatFloat(invoice.vat_amount) }} €</strong>
                    </td>
                </tr>
                <tr>
                    <td class="text-left py-0">
                        <strong>{{ $t('Tellimus kokku') }}</strong>
                    </td>
                    <td class="text-right py-0" style="width: 25%">
                        <strong>{{ Filters.formatFloat(invoice.price) }} €</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import Filters from '../filters';
import axios from 'axios';

export default {
    name: 'payment',
    setup() {
        return {
            Filters
        };
    },
    data() {
        return {
            invoice: {},
        };
    },
    mounted() {
        axios.get(Mrt.config.routes['account.eventRegister.step3-payment-data'])
            .then(
                (response) => {
                    this.invoice = response.data.invoice;
                }
            );
    },
};
</script>

<style scoped>

</style>
